import { Link } from "react-router-dom";
import "./Footer.css";
import { MdPhone } from "react-icons/md";
import { IoMdMailOpen } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { RiFacebookFill, RiInstagramFill, RiTwitterXFill } from "react-icons/ri";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { MdPolicy } from "react-icons/md";
import Button from "../Buttons/Button";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-content">
        <div className="container">
          <div className="footer-left">
            <h1>Contact Us</h1>
            <ul>
              <li>
                <a href="mailto:enquiry@belsoftsystems.com">
                  <span className="footer-icon">
                    <IoMdMailOpen />
                  </span>
                  <p>enquiry@belsoftsystems.com</p>
                </a>
              </li>
              <li>
                <span className="footer-icon">
                  <MdPhone />
                </span>
                <a href="tel:+2347079010708">
                  <p>+234 707 901 0708,</p>
                </a>
                <a href="tel:+2347017097447">
                  <p>+234 701 709 7447,</p>
                </a>
                <a href="tel:+2348129598167">
                  <p>+234 812 959 8167</p>
                </a>
              </li>
              <li>
                <span className="footer-icon">
                  <FaLocationDot />
                </span>
                <p>
                  Ridds Plaza Plot 740, Aguwan Anaekwe Street, Wuye Suite
                  046/47, Abuja-Nigeria
                </p>
              </li>
              <li>
                <span className="footer-icon">
                  <MdPolicy />
                </span>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <span className="footer-icon">
                  <MdPolicy />
                </span>
                <Link to="/terms-of-service">Terms of Service</Link>
              </li>
              <li>
                <span className="footer-icon">
                  <FaWhatsapp />
                </span>
                <Link to="/support">Support</Link>
              </li>
              <li>
                <Button text="Join Us" page="/join-us" />
              </li>
            </ul>
          </div>
          <div className="footer-right">
            <div className="social-icons">
              <a href="https://web.facebook.com/profile.php?id=61554162863933&_rdc=1&_rdr" target="_blank" rel="noopener noreferrer">
                <span className="social-icon">
                  <RiFacebookFill />
                </span>
              </a>
              <a href="https://www.instagram.com/belsoft_systems/" target="_blank" rel="noopener noreferrer">
                <span className="social-icon">
                  <RiInstagramFill />
                </span>
              </a>
              <a href="https://x.com/BELSOFT_SYSTEMS" target="_blank" rel="noopener noreferrer">
                <span className="social-icon">
                  <RiTwitterXFill />
                </span>
              </a>
              <a href="https://www.linkedin.com/company/belsoft-systems-ltd-abuja/" target="_blank" rel="noopener noreferrer">
                <span className="social-icon">
                  <FaLinkedinIn />
                </span>
              </a>
              <a href="https://wa.me/2347079010708" target="_blank" rel="noopener noreferrer">
                <span className="social-icon">
                  <FaWhatsapp />
                </span>
              </a>
            </div>

            {/* Newsletter subscription temporarily disabled
            <div className="reach-out">
              <h5>Subscribe to our Newsletter</h5>
              <form onSubmit={handleSubmit}>
                <div className="reach-out-box">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={handleEmailChange}
                    required
                    disabled={isSubmitting}
                  />
                  <Button text={isSubmitting ? "Sending..." : "Subscribe"} type="submit" disabled={isSubmitting} />
                </div>
              </form>

              {isSubmitted && <p className="footer-success">Thank you for subscribing!</p>}
              {error && <p className="footer-error" role="alert">{error}</p>}
            </div>
            */}
          </div>
        </div>
      </div>
      <div className="footer-container">
        <div className="f-copyright">
          <p>Copyright &copy; {new Date().getFullYear()} Belsoft Systems Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
